module.exports = __webpack_public_path__ + "img/flow1.fb7c0099.png";